import "./modalLibro.css";

const ifButton = (blog_gruid, idioma, titulo) => {
  if (blog_gruid !== null) {

    return <div class="buton_bp2_div"><a class="buton_bp2 espac" href={'https://www.ricardosalinas.com/blog/' + blog_gruid + '?lang=' + idioma}>Blog </a></div>;

  } else {
    if (titulo == 'Cómo pensar la economía' || titulo == 'How to Think About the Economy: A Primer') {
      console.log("Entro al libro");
      var blogtext2 = idioma == "es" ? "Descarga" : "Download";
      return <div class="buton_bp2_div"><a target="_blank" class="buton_bp2 espac" href={'https://play.google.com/store/books/details?id=Cdq-EAAAQBAJ&pli=1'}>{blogtext2} </a></div>;

    }
    else {
      return "";
    }

  }
};

const ModalLibroHome = ({
  isOpen,
  closeModal,
  variable1,
  variable2,
  variable3,
  variable4,
  variable5,
  variable6,
  variable7,
  variable8,
  variable9,
}) => {
  if (!isOpen) return null;
  return (
    <div className="modal">
      <div className="modalContent" style={{ zIndex: "10" }}>
        <div className="row" style={{ width: "auto" }}>
          <div className="colum1_Libr_modal">
            <img className="imgG_modalLibro" src={variable1} alt={variable2} />
          </div>
          <div className="colum2_Libr_modal">
            <div className="row_modal">
              <h3 className="modal-title">{variable3}</h3>
              <hr />
              <p className="card-text">{variable4}</p>
            </div>
            <div className="row_modal2">
              <div
                className="colum2_Libr_modal"
                style={{ marginLeft: "0", paddingLeft: "0.5rem" }}
              >
                <p className="datosLibr"> {variable5}</p>
                <p className="datosLibr"> {variable6}</p>
                <p className="datosLibr"> {variable7}</p>
              </div>
              {ifButton(variable8, variable9, variable3)}
            </div>
          </div>
        </div>
        <button className="botonPop" onClick={closeModal}>
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div className="background_gri" style={{ zIndex: "9" }}></div>
    </div>
  );
};
export default ModalLibroHome;
